var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.416504C5.82999 0.416504 0.416656 5.82984 0.416656 12.4998C0.416656 19.1698 5.82999 24.5832 12.5 24.5832C19.17 24.5832 24.5833 19.1698 24.5833 12.4998C24.5833 5.82984 19.17 0.416504 12.5 0.416504ZM15.7142 14.5903L14.1675 15.4844L12.6208 16.3786C10.6271 17.5265 8.99582 16.584 8.99582 14.2882V12.4998V10.7115C8.99582 8.40359 10.6271 7.47317 12.6208 8.62109L14.1675 9.51525L15.7142 10.4094C17.7079 11.5573 17.7079 13.4423 15.7142 14.5903Z",
    fill: "#CA9688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a29ece278362ed063482bf7e66316732.svg";
export { ForwardRef as ReactComponent };